export var avatarSmallWidth = '32px';
export var avatarMediumWidth = '96px';
export var avatarLargeWidth = '275px';